import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toBuyerListingRequests } from "@/lib/listingRequests";

export function useMyListingRequests(enabled = true) {
  return useQuery({
    queryKey: ["my-listing-requests"],
    enabled,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_my_listing_requests");
      if (error) throw error;
      return toBuyerListingRequests(data ?? []);
    },
  });
}
